import { render, staticRenderFns } from "./PathoItemsManagement.vue?vue&type=template&id=f86df22e"
import script from "./PathoItemsManagement.vue?vue&type=script&lang=js"
export * from "./PathoItemsManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports